export const AVERAGE_PRODUCTS = [
'1 - 29',
'30 - 99',
'100 - 199',
'200 - 499',
'500 - 1000',
'1001 - 5000',
'5001 - 10000',
'10001 - 50000',
'50001 o más',
]